module.exports = __webpack_public_path__ + "static/media/icon-help.d2d3fba5.svg";